import React, { useState } from 'react';
import { ColumnConfig } from '@components/design/migrated/Table';
import { CategoryGroup, CategoryLeaderboardPg, GroupState } from '@models/CategoryLeaderboard';
import CategoryLeaderboardTableCell from '../category-leaderboard-table-cell/CategoryLeaderboardTableCell';
import { GrowthTypes } from '@components/comparison-growth-selector/Types';
import { Filters, ShareType } from '@utils/pageConfig/Types';
import { useCategoryOrSegmentsLeaderboardGroupEventState } from '../utils/CategoryOrSegmentsLeaderboardGroupContext';
import { getGrandTotalValue } from '@utils/TotalUtils';

interface Props {
  categoryLeaderboardPg: CategoryLeaderboardPg;
  columns: ColumnConfig[];
  isStickyRow?: boolean;
  sortedColumn: string;
  className?: string;
  selectedGrowthType: GrowthTypes;
  countries: Filters;
  currencySymbol: string;
  selectedShareType: ShareType;
  groupState?: GroupState;
  isExplorePage?: boolean;
  isPreferenceOwner?: boolean;
}

export const getKeysByOrder = (columns: ColumnConfig[]): string[] => columns.map(({ headerKey }) => headerKey);

export const isCategoryGroup = (type: string): boolean => type === CategoryGroup;

const CategoryLeaderboardTableRow: React.FC<Props> = ({
  categoryLeaderboardPg,
  columns,
  isStickyRow,
  sortedColumn,
  className,
  selectedGrowthType,
  countries,
  currencySymbol,
  selectedShareType,
  groupState,
  isExplorePage,
  isPreferenceOwner,
}) => {
  const headerKeys = getKeysByOrder(columns);

  const [isRowHovered, setIsRowHovered] = useState<boolean>(false);
  const { selectProductGroupOrSegments, isEditGroupMode } = useCategoryOrSegmentsLeaderboardGroupEventState();
  const savedSelectedProductGroup = (e: React.MouseEvent<HTMLTableRowElement>) => {
    e.preventDefault();

    if (
      (isEditGroupMode.isEditMode &&
        isEditGroupMode.groupDetails.segmentOrPgValue.includes(categoryLeaderboardPg.segmentOrPg)) ||
      groupState?.isGroupingProductGroup ||
      groupState?.isGroupingHeader ||
      categoryLeaderboardPg.segmentOrPg === getGrandTotalValue()
    ) {
      return;
    }

    selectProductGroupOrSegments(categoryLeaderboardPg.segmentOrPg);
  };

  return (
    <tr
      className={className}
      onClick={(event) => savedSelectedProductGroup(event)}
      onMouseEnter={() => setIsRowHovered(true)}
      onMouseLeave={() => setIsRowHovered(false)}
    >
      {headerKeys.map((headerKey) => {
        return (
          <CategoryLeaderboardTableCell
            key={headerKey}
            headerKey={headerKey}
            categoryLeaderboardPg={categoryLeaderboardPg}
            isStickyRow={isStickyRow}
            isCategoryGroup={isCategoryGroup(headerKey)}
            sortedColumn={sortedColumn}
            selectedGrowthType={selectedGrowthType}
            countries={countries}
            currencySymbol={currencySymbol}
            selectedShareType={selectedShareType}
            isRowHovered={isRowHovered}
            groupState={groupState}
            isExplorePage={isExplorePage}
            isPreferenceOwner={isPreferenceOwner}
          />
        );
      })}
    </tr>
  );
};

export default CategoryLeaderboardTableRow;
